(function () {
    var
        originalParse = JSON.parse,
        originalStringify = JSON.stringify,
        rISODateOrTime = /^(?:(\d{4})-([01]\d)-([0-3]\d)T([0-2]\d):([0-5]\d):([0-5]\d)(?:\.(\d{1,3})\d*)?([+-][0-2]\d:[0-5]\d|Z)?|PT(?:([0-2]?\d)H)?(?:([0-5]?\d)M)?(?:([0-5]?\d)(?:\.(\d{1,3})\d*)?S)?)$/;

    JSON.parse = function (text, reviver) {
        return originalParse(text, reviverProxy);

        function reviverProxy(key, value) {
            if (typeof value === 'string') {
                var match = rISODateOrTime.exec(value);
                if (match) {
                    // Is a Time PT{XX}H{XX}M{XX.XXXXX}S ?
                    if (match[9]) {
                        var now = new Date();
                        value = new Date(now.getFullYear(), now.getMonth(), now.getDate(), match[9] || 0, match[10] || 0, match[11] || 0, match[12] || 0);
                    }

                    // Is a Date with either trailing "Z" (UTC) or timezone offset "-04:20". ? 
                    else if (match[8]) {
                        value = new Date(value);
                    }

                    // Is a Local Date (no timezone or utc) ?
                    else {
                        value = new Date(match[1], match[2] - 1, match[3], match[4], match[5], match[6], match[7] || 0);
                    }
                }
            }

            if (isFunction(reviver))
                return reviver.call(this, key, value);
            else
                return value;
        }
    }

   
    Date.prototype.toLocalISOString = function () {
        if (isNaN(this.getTime()))
            return null;
        return new Date(this.getTime() - this.getTimezoneOffset() * 60000).toISOString().substr(0, 23);
    }

    Date.prototype.toDurationString = function () {
        if (isNaN(this.getTime()))
            return null;
        return 'PT' + [this.getHours(), this.getMinutes(), this.getSeconds() + this.getMilliseconds() / 1000].map(function (value, idx) {
            return value && value + "HMS".substr(idx, 1) || '';
        }).join('');
    }

    function isFunction(value) {
        return typeof value === 'function';
    }
})();